var BlockView = require('views/block/base-block-view');
var ef = require('ef/ef');
var ContentProvider = require('services/content-provider');

var StudentEngagementSurvey = BlockView.extend({
  className: 'engagement-survey',
  initialize: function() {
    if(EF.options.local) {
      try {
        this.model.set('survey', new ef.Models.Survey(
          Object.assign(
            require(`local-data/surveys/${this.model.get('slug')}`),
            { slug: this.model.get('slug') }
          )
        ));
        this.model.get('survey').initResponseSet(
          { success: responseSet => this.model.set('responseSet', responseSet) }
        );
      } catch(e) {
        console.error(`Could not find local data in local-data/surveys/${this.model.get('slug')}`);
      }
    } else {
      this.model.set('survey', new ef.Models.Survey({ slug: this.model.get('slug') }));
      ContentProvider.SurveyService.getSurvey(this);
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    this.delegate('change', '.answer input', e => {
      this.delegate('click', 'label.answer', labelEvent => {
        labelEvent.stopImmediatePropagation();  // stop bootstrap from adding active class
      });
      this.$('label.answer').addClass('disabled');
      this.$('.answer input').prop('disabled', true);
      if(this.model.has('responseSet')) {
        ContentProvider.SurveyService.saveSurveyResponse(this, e.target.dataset).then( () => {
          this.readyToGo();
        });
      } else {
        this.readyToGo();
      }
    });
  }
});

module.exports = StudentEngagementSurvey;
